import { notificationActions } from "../../actionTypes";

const initialState = {
	notifications: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case notificationActions.FETCH_NOTIFICATIONS: {
			return { ...state, fetching: true };
		}

		case notificationActions.FETCH_NOTIFICATIONS_FULFILLED: {
			return state.notifications.current_page < action.payload.current_page
				? {
						...state,
						fetching: false,
						fetched: true,
						notifications: {
							...action.payload,
							data: state.notifications.data
								? [...state.notifications.data, ...action.payload.data]
								: action.payload.data,
						},
				  }
				: {
						...state,
						fetching: false,
						fetched: true,
						notifications: action.payload,
				  };
		}

		case notificationActions.FETCH_NOTIFICATIONS_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
